export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13868.2eb68ed8.jpg";